module.exports = __webpack_public_path__ + "fonts/adellesans-bold-webfont.f70cc612.woff2";